var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-height default-background d-flex justify-content-center align-items-center"},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }